import styled, { css } from 'styled-components';

const Container = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    box-sizing: border-box;
    flex-shrink: 0;

    ${({ responsive }) =>
        responsive &&
        css`
        @media (max-width: 768px) {
            flex-direction: column;
        }
    `}
`;

const GenericHeader = ({ children, responsive }) => {
    return <Container responsive={responsive}>
        {children}
    </Container>;
};

export default GenericHeader;